<template>
  <router-view></router-view>
</template>

<script>
import Vue from "vue";
import VueNativeSock from "vue-native-websocket";
import {
  setUserToken,
  getSelectedDeviceToken,
  getUserToken,
  setTokenRenewal,
  getTokenRenewal
} from "@/storage/memoryStorage";
import config from "@/config/config";
import axios from "axios";

//Highchats plugin
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import dataInit from "highcharts/modules/data";
import exportingInit from "highcharts/modules/exporting";
import exportDataInit from "highcharts/modules/export-data";
import highchartsMoreInit from "highcharts/highcharts-more";
import stockInit from "highcharts/modules/stock";
import xrangeInit from "highcharts/modules/xrange";
import drilldownInit from "highcharts/modules/drilldown";
import boostInit from "highcharts/modules/boost";
import noDataToDisplayInit from "highcharts/modules/no-data-to-display";

exportingInit(Highcharts);
exportDataInit(Highcharts);
dataInit(Highcharts);
highchartsMoreInit(Highcharts);
stockInit(Highcharts);
xrangeInit(Highcharts);
drilldownInit(Highcharts);
boostInit(Highcharts);
noDataToDisplayInit(Highcharts);
Vue.use(HighchartsVue);

export default {
  data() {
    return {
      reconnect: true,
      reconnectAttempts: 0,
      tokenRenewTimeOut: 0
    };
  },

  computed: {
    deviceList() {
      return this.$store.getters.getDeviceList;
    },
    isConnected() {
      return this.$store.getters.isConnected;
    },
    getLocation() {
      return this.$store.getters.getSettings.localization;
    },
    getAuth() {
      return this.$store.getters.getAuth;
    }
  },

  mounted() {
    Highcharts.setOptions({
      lang: {
        viewFullscreen: this.$lang.charts.viewFullscreen,
        printChart: this.$lang.charts.printChart,
        downloadPNG: this.$lang.charts.downloadPNG,
        downloadJPEG: this.$lang.charts.downloadJPEG,
        downloadPDF: this.$lang.charts.downloadPDF,
        downloadSVG: this.$lang.charts.downloadSVG,
        downloadCSV: this.$lang.charts.downloadCSV,
        downloadXLS: this.$lang.charts.downloadXLS,
        viewData: this.$lang.charts.viewData,
        openInCloud: this.$lang.charts.openInCloud,
        contextButtonTitle: this.$lang.charts.contextButtonTitle,
        resetZoom: this.$lang.charts.resetZoom,
        loading: this.$lang.charts.loading,
        weekdays: this.$lang.charts.weekdays,
        months: this.$lang.charts.months,
        shortMonths: this.$lang.charts.shortMonths,
        scalerChange: this.$lang.charts.scaleChange,
        drillUpText: this.$lang.charts.drillUpText,
        noData: this.$lang.charts.noData
      }
    });
  },

  methods: {
    googleTokenRenew() {
      //console.log("Call renew function", new Date());
      try {
        window.gapi.auth2.init({
          client_id: config.API_KEYS.GOOGLE.OAUTH,
          scope: "profile email"
        });
        const googleAuth = window.gapi.auth2.getAuthInstance();
        //console.log("Google Signed in: ", googleAuth.isSignedIn.get());

        const tokenRenewal = getTokenRenewal();
        if (tokenRenewal) {
          tokenRenewal.renew_count++;
          setTokenRenewal(tokenRenewal);
        } else {
          setTokenRenewal({ renew_count: 1 });
        }

        if (tokenRenewal.renew_count > 200) {
          googleAuth.signOut();
        }

        googleAuth.currentUser
          .get()
          .reloadAuthResponse()
          .then(() => {
            const authInstance = window.gapi.auth2
              .getAuthInstance()
              .currentUser.get();
            const access_token = authInstance.getAuthResponse(
              "includeAuthorizationData"
            ).access_token;

            const profile = authInstance.getBasicProfile();
            const tokenExpiration_ms = authInstance.getAuthResponse(
              "includeAuthorizationData"
            ).expires_at;

            axios({
              method: "POST",
              url: this.$ENDPOINTS.API_R + "/auth/google",
              data: {
                token: access_token
              }
            }).then(response => {
              if (response.data.status === "OK") {
                this.$store.commit("setDeviceList", response.data.data);
                setUserToken(response.data.user.token);

                this.$store.commit("setAuth", {
                  id: 2,
                  type: "google",
                  expiration: tokenExpiration_ms,
                  user: profile.getEmail(),
                  avatar: profile.getImageUrl(),
                  user_name: profile.getName(),
                  applications: response.data.user.applications
                });

                Vue.prototype.$disconnect();
                this.$store.commit("setConnected", false);
                this.reconnectAttempts = 0;

                let timeOut =
                  tokenExpiration_ms - new Date().getTime() - 500000;
                if (timeOut <= 0) {
                  //console.log("Using constant timeout to token renew");
                  timeOut = 3100000;
                }
                //console.log("(Function) Next renew time: ", new Date(new Date().getTime() + timeOut));
                this.tokenRenewTimeOut = setTimeout(() => {
                  this.googleTokenRenew();
                }, timeOut);
              }
            });
          });
      } catch (error) {
        //console.log(error);
        //console.log("(error) Next renew time: ", new Date(new Date().getTime() + 30000));
        this.tokenRenewTimeOut = setTimeout(() => {
          this.googleTokenRenew();
        }, 30000);
      }
    },

    onMessage(data) {
      try {
        const wsMessage = JSON.parse(data.data);
        //console.log("WS msg: ", wsMessage);

        if (wsMessage.status === "FAIL") {
          this.reconnect = false;
          //console.log("WebSocket error code: ", wsMessage.code);

          switch (wsMessage.code) {
            case 714:
            case 722:
              //this.$store.commit("Logout");
              this.$router.push({ path: "/login" });
              break;
            case 716:
            case 720:
              this.$router.push({ path: "/login" });
              break;
          }
        } else {
          if (wsMessage.topic == "Notification") {
            try {
              this.$store.commit("setNotificationList", wsMessage.data);
            } catch (err) {}
          } else if (wsMessage.topic == "State") {
            let deviceList = this.deviceList;
            const deviceIndex = deviceList.findIndex(
              d => d.mac == wsMessage.device
            );
            if (deviceIndex != -1) {
              Vue.set(deviceList[deviceIndex], "status", wsMessage.data.status);
              Vue.set(deviceList[deviceIndex], "fw", wsMessage.data.fw);

              //AppliedPrecision
              if (wsMessage.data.connection) {
                Vue.set(deviceList[deviceIndex], "connection",wsMessage.data.connection);
              }
              if (wsMessage.data.device) {
                Vue.set(deviceList[deviceIndex], "device", wsMessage.data.device);
              }
              this.$store.commit("setDeviceListStatus", deviceList);
            }
          } else if (
            wsMessage.topic === "Data" ||
            wsMessage.topic === "AccuTest/Data" ||
            wsMessage.topic === "AccuTest/State" ||
            wsMessage.topic === "Upgrade"
          ) {
            this.$store.commit("setDataMessage", wsMessage);
          }
        }
      } catch (err) {
        //console.log("Error parsing message from WS");
        //console.log(err);
      }
    },

    onOpenWS() {
      this.$store.commit("setConnected", true);
    },

    onWSClose() {
      Vue.prototype.$disconnect();
      this.$store.commit("setConnected", false);
      if (this.reconnect) {
        setTimeout(() => {
          this.WSReconnect();
        }, 15000);
      }
    },

    WSReconnect() {
      if (!this.isConnected) {
        if (this.reconnectAttempts < config.websocket.reconnectAttempts) {
          Vue.prototype.$connect(this.$ENDPOINTS.API_WS);
          Vue.prototype.$socket.onopen = this.onOpenWS;
          Vue.prototype.$socket.onclose = this.onWSClose;
          Vue.prototype.$socket.onmessage = this.onMessage;

          this.reconnectAttempts++;
        }
      }
    }
  },

  created() {
    this.$lang.setLang(this.getLocation);

    if (this.getAuth.id === 2) {
      const timeOut = this.getAuth.expiration - new Date().getTime() - 500000;
      //console.log("(created) Next renew time: ", new Date(new Date().getTime() + timeOut));
      if (timeOut > 0) {
        this.tokenRenewTimeOut = setTimeout(() => {
          this.googleTokenRenew();
        }, timeOut);
      } else {
        //console.log("Token renew timeout error");
      }
    }

    if (!this.isConnected) {
      Vue.use(VueNativeSock, this.$ENDPOINTS.API_WS, {
        connectManually: true
      });

      Vue.prototype.$connect(this.$ENDPOINTS.API_WS);
      Vue.prototype.$socket.onopen = this.onOpenWS;
      Vue.prototype.$socket.onclose = this.onWSClose;
      Vue.prototype.$socket.onmessage = this.onMessage;
    }
  },

  beforeDestroy() {
    clearTimeout(this.tokenRenewTimeOut);
    this.reconnect = false;
    Vue.prototype.$disconnect();
    delete Vue.prototype.$socket;
    this.$store.commit("setConnected", false);
  }
};
</script>
